import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-regular-svg-icons";

import { ButtonNew } from "components/buttonNew";

interface ITeesheetDatePickerNavProps {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
  children: React.ReactNode;
}

function addDays(date: Date, days: number) {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + days);
  return nextDate;
}

export default function TeesheetDatePickerNav(props: ITeesheetDatePickerNavProps) {
  const { t } = useTranslation();

  return (
    <div className="teesheet-date-picker-nav">
      <ButtonNew
        type="tertiary"
        size="medium"
        className="teesheet-date-picker-nav-button"
        onClick={() => props.onDateChange(addDays(props.selectedDate, -1))}
        aria-label={t("Previous day")}
        icon={<FontAwesomeIcon icon={faChevronLeft} />}
      />
      <div className="teesheet-date-picker-nav-picker">{props.children}</div>
      <ButtonNew
        type="tertiary"
        size="medium"
        className="teesheet-date-picker-nav-button"
        onClick={() => props.onDateChange(addDays(props.selectedDate, 1))}
        aria-label={t("Next day")}
        icon={<FontAwesomeIcon icon={faChevronRight} />}
      />
    </div>
  );
}
